import Splide from '@splidejs/splide';

class PlaceCross {
    constructor() {
        const elem = document.querySelector('.splide.storesSlider');

        if (!elem) return;

        const splide = new Splide(elem, {
            perMove: 1,
            perPage: 3,
            pagination: false,
            arrows: true,
            autoWidth: true,
            focus: 'center',
            type: 'loop',
            gap: '10vw',
        });
        splide.mount();

        const moveArrows = (back = true) => {
            const arrows = elem.querySelectorAll('.splide__arrow');
            arrows.forEach((a) => {
                a.style.zIndex = back ? 0 : null; // eslint-disable-line
            });
        };

        splide.on('move', () => {
            moveArrows();
        });
        splide.on('drag', () => {
            moveArrows();
        });
        splide.on('moved', () => {
            moveArrows(false);
        });

        // elem.querySelectorAll('a.group').forEach((group) => {
        //     let hover = false;
        //     const sticker = group.parentNode.querySelector('.eventSticker');
        //     if (!sticker) return;

        //     [group, sticker].forEach((item) => {
        //         if (!item) return;
        //         item.addEventListener('mouseenter', () => {
        //             if (hover) return;
        //             hover = true;
        //             sticker.children[1].style.display = 'none';
        //             setTimeout(() => {
        //                 sticker.children[1].style.display = 'block';
        //             }, 45);
        //         });
        //     });
        //     [group, sticker].forEach((item) => {
        //         if (!item) return;
        //         item.addEventListener('mouseleave', () => {
        //             if (hover) hover = false;
        //         });
        //     });
        // });
    }
}

export default PlaceCross;
